// Toggle from DevTools console:
//   localStorage.chatmapDebug = '1'; location.reload();   // enable
//   localStorage.removeItem('chatmapDebug'); location.reload();   // disable
//
// Filter the DevTools console by `[chatmap-` to grab everything.
// Sub-filters: `[chatmap-tween]` `[chatmap-vis]` `[chatmap-cam]`
//              `[chatmap-round]` `[chatmap-mount]`

export type ChatmapLogCategory =
  | 'tween'   // per-node tween events (NEW-MOUNT, TARGET-CHANGE, SETTLED, REMOVE)
  | 'vis'     // wrapper visibility transitions (MutationObserver — bug signature)
  | 'cam'     // camera events (fitView, inFlightTurnId, inFlightBBoxKey, cameraBusy)
  | 'round'   // round boundaries (inFlightTurnId null↔id transitions)
  | 'mount';  // hook mount/unmount, registry-resize thresholds

// Read live every call — no cache. localStorage.getItem is sub-µs and
// caching creates a footgun: operators flipping the toggle without
// reload (the obvious DevTools workflow) would see silent no-ops.
// All callsites are debug-gated; if the toggle is off, this returns
// false immediately and the chatmapLog callsite early-returns.
export function isChatmapDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage?.getItem('chatmapDebug') === '1';
  } catch {
    return false;
  }
}

export function chatmapLog(
  cat: ChatmapLogCategory,
  event: string,
  data?: Record<string, unknown>,
): void {
  if (!isChatmapDebugEnabled()) return;
  const t = (
    typeof performance !== 'undefined' ? performance.now() : Date.now()
  ).toFixed(0);
  const prefix = `[chatmap-${cat}] t+${t}ms ${event}`;
  if (data === undefined) {
    // eslint-disable-next-line no-console
    console.log(prefix);
  } else {
    // eslint-disable-next-line no-console
    console.log(prefix, data);
  }
}
